const s3Regex1 = /^https:\/\/s3-us-west-2\.amazonaws\.com\/(.*?)\/(.*)$/;
const s3Regex2 = /^https:\/\/(.*)\.s3\.amazonaws\.com\/(.*)$/;

export function isS3Url(url) {
    return s3Regex1.test(url) || s3Regex2.test(url);
}

export function parseS3Url(url) {
    const parts = url.match(s3Regex1) || url.match(s3Regex2);
    if (!parts) {
        console.log('unrecognized S3 URL format:', url);
        throw new Error('unrecognized S3 URL format');
    }
    return {
        bucket: parts[1],
        key: parts[2],
    };
}

export function buildS3Url(bucket, key) {
    return `https://s3-us-west-2.amazonaws.com/${bucket}/${key}`;
}

export default {
    isS3Url,
    parseS3Url,
    buildS3Url,
};



// WEBPACK FOOTER //
// ./src/packages/s3-utils/index.js